export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-first-aid-6ceed55cce903f8f1691567a337141c0.svg";